import { API_URL } from '../config';
import fetchApi from "../fetchApi";
export const GetReportTypes = async () => {
    try {
        const options = {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            redirect: 'follow'
        }

        return await fetchApi(`card-issuing/company/report/config`, options);

    } catch (error) {
        console.error('Error fetching report types:', error);
        throw error;
    }
};